export function getRoomLogoUrl(room: {
  icoModel: {
    url: string;
    sizes: { icon: { file: string } } | null;
  } | null;
  organisationModel: { logo: { url: string } };
}): string {
  if (room.icoModel !== null) {
    return room.icoModel.sizes !== null
      ? room.icoModel.sizes.icon.file
      : room.icoModel.url;
  }
  return room.organisationModel.logo.url;
}
